module.exports = __webpack_public_path__ + "static/media/complete-01.dac5ee14.svg";